<template>
  <div id="topRight">
    <div class="bg-color-black">
      <div class="cc-header">
        <div>各学校单日金额</div>
      </div>
      <div class="d-flex jc-center">
        <dv-scroll-ranking-board :config="config" class="rankChart" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {},
    };
  },
  mounted() {
    this.initData();
    // 定时器刷新，5分钟
    let _this = this;
    setInterval(() => {
      _this.initData();
    }, 1000 * 60 * 5);
  },
  methods: {
    initData() {
      let _this = this;
      this.$http.get("/dataView/pay/getDayMoneyRank").then((res) => {
        if (res.data.code === 200) {
          // var array = [];
          // array.push({"name":"测试校","value":0.02});
          // array.push({"name":"测试校1","value":0.02});
          // array.push({"name":"测试校2","value":0.07});
          // array.push({"name":"测试校3","value":0.03});
          // array.push({"name":"测试校4","value":0.05});
          // array.push({"name":"测试校5","value":0.1});
          // array.push({"name":"测试校6","value":0.06});
          // array.push({"name":"测试校7","value":0.06});
          // array.push({"name":"测试校8","value":0.07});
          // array.push({"name":"测试校9","value":0.01});
          // array.push({"name":"测试校10","value":0.03});
          // array.push({"name":"测试校11","value":0.08});
          // res.data.result = array;
          var config = {
            data: res.data.result,
            rowNum: 8, //表格行数
            waitTime: 1000,
            unit: "万元", //数值单位
          };
          _this.config = config;
        }
      });
    },
  },
};
</script>

<style lang="scss">
#topRight {
  .cc-header {
    height: 0.5rem;
    padding-top: 1rem;
    color: #fff;
    font-size: 0.55rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .rankChart {
    width: 12rem;
    height: 13rem;
    margin-top: 0.6rem;
    font-size: 0.55rem;
  }

  .dv-scroll-ranking-board .ranking-column .inside-column {
    height: 0.4rem;
    border-radius: 15px;
    background: linear-gradient(to left, #00bcd4, #f59101);
  }

  .dv-scroll-ranking-board .ranking-column {
    border-bottom: 0;
  }

  .dv-scroll-ranking-board .ranking-info {
    font-size: 0.5rem;
    color: #fff;
  }

  .dv-scroll-ranking-board .ranking-info .rank {
    width: 50px;
    color: #fff;
  }

  .dv-scroll-ranking-board .row-item {
    height: 1.6rem !important;
  }
}
</style>
